import {
    EmojiByGroup,
    EmojiCollection,
    EmojiDefinition,
    EmojiProviderService,
} from '../../ng-services/emoji-provider.service';

(function () {
    class EmojiPickerComponent {
        static $inject = ['EmojiProviderService', '$scope'];

        filterValue!: string;

        coordinates: any;
        onEmojiSelected?: ({ $value }: { $value: EmojiDefinition }) => any;

        loaded = false;
        emojis?: EmojiCollection;
        emojisByCategory?: { [category: string]: EmojiCollection };
        frequentlyUsed?: EmojiCollection;

        constructor(private emojiProviderService: EmojiProviderService, private $scope: ng.IScope) {}

        $onInit() {
            // $digest is necessary, as response from cache doesnt get into $digest cycle
            // this resulted in a weird behaviour, where clicking emojis only worked after second click
            this.emojiProviderService.getEmoji$().subscribe((emojiByGroup: EmojiByGroup) => {
                this.emojisByCategory = emojiByGroup;

                // flatten the emojis into a single array
                this.emojis = Object.values(emojiByGroup).reduce(
                    (previousValue, currentValue) => [...previousValue, ...currentValue],
                    []
                );

                this.frequentlyUsed = this.emojis.filter((e) =>
                    this.emojiProviderService.getFrequentlyUsed().includes(e.name)
                );

                this.loaded = true;

                this.$scope.$digest();
            });
        }

        onFilterChanged = (filter: string) => {
            this.filterValue = filter;
        };

        private _onEmojiSelected(emoji: EmojiDefinition) {
            this.onEmojiSelected && this.onEmojiSelected({ $value: emoji });
            this.emojiProviderService.addFrequentlyUsed(emoji);
        }
    }

    angular.module('tradersyard').component('tyEmojiPicker', {
        template: `<div ng-style="$ctrl.coordinates" class="emoji_picker" is-uib>
    <ty-filter placeholder="Search" on-change="$ctrl.onFilterChanged"/>
    <div class="emoji_picker__spinner" ng-if="!$ctrl.loaded">
        <ty-loading-spinner ng-if="!$ctrl.loaded"/>
    </div>

    <ty-emoji-picker-emojis ng-if="$ctrl.loaded"
        filter-value="$ctrl.filterValue"
        emojis="$ctrl.emojis"
        emojis-by-category="$ctrl.emojisByCategory"
        frequently-used="$ctrl.frequentlyUsed"
        on-emoji-selected="$ctrl._onEmojiSelected($value)"
    />
    </div>
`,
        controller: EmojiPickerComponent,
        bindings: {
            coordinates: '<',
            onEmojiSelected: '&',
        },
    });
})();
